import { render } from "./QuizResults.vue?vue&type=template&id=28d63ed6&bindings={\"score\":\"props\",\"maxScore\":\"props\",\"playAgain\":\"setup\"}"
import script from "./QuizResults.vue?vue&type=script&lang=js"
export * from "./QuizResults.vue?vue&type=script&lang=js"
script.render = render

export default script